import React from 'react';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { IconSurgePremium } from '../Icons';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var PayLabel = function (_a) {
    var payText = _a.payText, _b = _a.isSurgePay, isSurgePay = _b === void 0 ? false : _b, _c = _a.displayAsAdditive, displayAsAdditive = _c === void 0 ? false : _c;
    var t = useTranslation().t;
    return (React.createElement(PayLabelContainer, { alignItems: "center", dataTestId: "PayLabel", gridGap: "S100" },
        React.createElement(Text, { dataTestId: "PayLabelText", fontSize: "T100", fontWeight: "bold" },
            displayAsAdditive && '+', "".concat(payText, "/").concat(t('shift_management_common_time_hourAbbr'))),
        isSurgePay && (React.createElement(IconSurgePremium, { dataTestId: "PayLabelTextSurgeIcon" }))));
};
var PayLabelContainer = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n    ".concat("\n            height: fit-content;\n            background-color: ".concat(theme.selectors.color('neutral05'), ";\n            padding: ").concat(theme.selectors.space('S100'), "px \n                        ").concat(theme.selectors.space('S300'), "px;\n        "), "\n  ");
});
